import React, { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";

const NavBar = () => {
  const [nav, setNav] = useState(false);
  const [progress, setProgress] = useState(0);
  const links = ["Home", "About", "Projects", "Experience", "Resume", "Contact"];

  useEffect(() => {
    const update = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(max ? (window.scrollY / max) * 100 : 0);
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <>
      <header className="sticky top-0 z-50 px-3 pt-3 sm:px-5">
        <div className="mx-auto flex h-14 max-w-7xl items-center justify-between rounded-2xl border border-white/50 bg-[#f4f0e8]/70 px-4 shadow-[0_8px_30px_rgba(23,32,28,.08)] backdrop-blur-xl sm:px-6 lg:px-8">
          <a href="#Home" className="group flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#17201c] text-xs font-bold text-[#c9d84a] transition group-hover:rotate-12">VA</span>
            <span className="text-sm font-bold tracking-tight sm:text-base">Vijay A<span className="text-[#e65335]">.</span></span>
          </a>
          <ul className="hidden items-center gap-1 md:flex">
            {links.map((link) => <li key={link}><Link to={link} smooth duration={500} offset={-90} className="cursor-pointer rounded-full px-3 py-1.5 text-xs text-[#65706a] transition hover:bg-[#17201c] hover:text-[#f4f0e8] lg:px-3.5 lg:text-sm">{link}</Link></li>)}
          </ul>
          <button aria-label="Toggle navigation" onClick={() => setNav(!nav)} className="rounded-full p-2 text-lg transition hover:bg-[#17201c] hover:text-[#f4f0e8] md:hidden">{nav ? <FaTimes /> : <FaBars />}</button>
          {nav && <ul className="absolute inset-x-3 top-[4.5rem] flex flex-col gap-1 rounded-2xl border border-white/60 bg-[#f4f0e8]/90 p-3 shadow-xl backdrop-blur-xl md:hidden">{links.map((link) => <li key={link}><Link onClick={() => setNav(false)} to={link} smooth duration={500} offset={-90} className="block cursor-pointer rounded-xl px-4 py-2.5 text-base hover:bg-[#17201c] hover:text-[#f4f0e8]">{link}</Link></li>)}</ul>}
        </div>
      </header>
      <div className="progress-rail"><span style={{ height: `${progress}%` }} /></div>
    </>
  );
};

export default NavBar;
